import { useState } from 'react';

import { TextField } from '@mui/material';

import StepScreen from '@/karehero-app/access/StepScreen';
import { type Account } from '@/karehero-app/access/AccountBar';

// Partner path of the access flow.
const PartnerCodeScreen = ({
  onSubmit,
  onBack,
  error,
  account,
}: {
  onSubmit: (code: string) => void;
  onBack: () => void;
  /** What the check said, under the field. See ACCESS_ERRORS. */
  error?: string;
  /** The app bar and its account sheet. See StepScreen. */
  account?: Account;
}) => {
  const [code, setCode] = useState('');

  return (
    <StepScreen
      title='Enter your partner code'
      description='Your partner gave you this code.'
      primaryLabel='Continue'
      onPrimary={() => onSubmit(code.trim())}
      onBack={onBack}
      account={account}
    >
      <TextField
        slotProps={{ inputLabel: { shrink: true } }}
        label='Partner code'
        placeholder='e.g. TIME-001'
        variant='filled'
        value={code}
        onChange={(e) => setCode(e.target.value)}
        error={Boolean(error)}
        helperText={error ?? 'Check the email or letter from your partner.'}
        fullWidth
      />
    </StepScreen>
  );
};

export default PartnerCodeScreen;
